import React from 'react';
import { connect } from 'react-redux';
import InboxComponent from '../../components/inboxPanel/Inbox';
import {
  extractSelectedInboxTab,
  isAPartnerProtector,
  isSpecialist,
  isSpecialistLite,
  extractTicketsFromState,
} from '../../extractFromState';
import { handleReviewTicketSelect, handleValidationTicketSelect } from 'actions';

export const mapStateToProps = (state) => {
  return {
    isAdmin: isSpecialist(state),
    isAPartnerProtector: isAPartnerProtector(state),
    selectedInboxTab: extractSelectedInboxTab(state),
    isSpecialistLite: isSpecialistLite(state),
    loading: state.ui.loading,
    reviewTickets: state.tickets.reviewTickets,
    hasTickets: extractTicketsFromState(state).length > 0,
  };
};

const mapDispatchToProps = {
  handleReviewTicketSelect,
  handleValidationTicketSelect,
};

const InboxContainer = connect(mapStateToProps, mapDispatchToProps)((props) => <InboxComponent {...props} />);

export default InboxContainer;
